// Floating "Back to Admin" pill — only shown when the logged-in user is an admin
// who navigated to a non-admin portal (customer/driver/mujahez/rep) for inspection.
import { useNavigate } from "react-router-dom";
import { ArrowRight, Shield } from "lucide-react";
import { useAuth } from "../contexts/AuthContext";

const BackToAdminButton = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  if (!user || user.role !== "admin") return null;

  return (
    <button
      onClick={() => navigate("/admin")}
      data-testid="back-to-admin-fab"
      title="رجوع للإدارة"
      className="fixed bottom-4 left-4 z-[80] bg-gradient-to-l from-[#1E3A5F] to-[#3B82F6] hover:from-[#152a45] hover:to-[#2563EB] text-white px-4 py-2.5 rounded-full shadow-2xl flex items-center gap-2 text-sm font-bold border-2 border-white/30"
    >
      <Shield className="w-4 h-4" />
      رجوع للإدارة
      <ArrowRight className="w-4 h-4 rotate-180" />
    </button>
  );
};

export default BackToAdminButton;
